import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfigService } from 'src/app/core/services/api-config/api-config.service';
import {
  CreateInfoResponse,
  CreateServiceRequestType,
  RequestsDetail,
  RequestsResponse,
  UpdateInfoResponse,
  UpdateServiceRequestType,
} from 'src/app/shared/types/requests.types';

@Injectable({
  providedIn: 'root',
})
export class RequestsService {
  constructor(
    private http: HttpClient,
    private ApiConfigService: ApiConfigService
  ) { }

  private get baseUrl(): string {
    return `${this.ApiConfigService.apiUrl}/orders`;
  }

  getRequests(): Observable<RequestsResponse> {
    return this.http.get<RequestsResponse>(`${this.baseUrl}`);
  }

  getRequestDetail(id: number): Observable<RequestsDetail> {
    return this.http.get<RequestsDetail>(`${this.baseUrl}/${id}`);
  }

  getCreateInfo(): Observable<CreateInfoResponse> {
    return this.http.get<CreateInfoResponse>(`${this.baseUrl}/create-info`);
  }

  createServiceRequest(
    body: CreateServiceRequestType
  ): Observable<{ data: any }> {
    return this.http.post<{ data: any }>(`${this.baseUrl}`, body);
  }

  getUpdateInfo(id: number): Observable<UpdateInfoResponse> {
    return this.http.get<UpdateInfoResponse>(`${this.baseUrl}/edit-info/${id}`);
  }

  updateServiceRequest(
    body: UpdateServiceRequestType
  ): Observable<{ data: any }> {
    return this.http.put<{ data: any }>(`${this.baseUrl}`, body);
  }

  deleteRequest(id: number) {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }

}
